import React, { useState, memo } from "react";
import { Outlet } from "react-router";
import { useAuth } from "../contexts/AuthContext";
import TeacherHeader from "./ui/TeacherHeader";
import TeacherSidebar from "./ui/TeacherSidebar";
import Footer from "./ui/Footer";

const TeacherLayout: React.FC = memo(() => {
  const { user } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  if (!user || user.role !== "TEACHER") {
    return null; // This should be handled by ProtectedRoute
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <TeacherSidebar
        isCollapsed={isSidebarCollapsed}
      />
      <div
        className={`flex-1 transition-all duration-300 ${
          isSidebarCollapsed ? "lg:ml-20" : "lg:ml-[280px]"
        }`}
      >
        <TeacherHeader onMenuClick={toggleSidebar} />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
});

TeacherLayout.displayName = "TeacherLayout";

export default TeacherLayout;
